





















import { Component, Prop, Vue } from 'vue-property-decorator'
import { dwollaCustomerIdFromUrl } from '@/util/dwolla'

@Component
export default class DocumentUploadDialog extends Vue {
  
  @Prop({ default: false }) readonly opened!: boolean

  closeDialog() {
    this.$emit('update:opened', false)
  }
  
  get me() {
    return this.$store.getters.me
  }

  customerId(customerUrl: string) {
    return dwollaCustomerIdFromUrl(customerUrl)
  }
}
